import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {loginItem, loginItemList} from '../../../_animations/loginAnimations';
import {first} from 'rxjs/operators';
import {AuthService} from '../../../_services/auth/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', '../../../../loginForm.scss'],
  animations: [loginItemList, loginItem]
})
export class ResetPasswordComponent implements OnInit {

  message: string;
  messageType: string;
  form: FormGroup;
  loading: boolean;
  constructor(private formBuilder: FormBuilder, private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.loading = false;
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  resetPassword() {
    this.loading = true;
    this.auth
        .resetPassword(this.form.controls.email.value)
        .pipe(first())
        .subscribe(
          response => {
            const status = response.status;
            if (status === 'success') {
              this.router.navigate(['/login'], {
                state: { mode: 'reset_email' }
              });
              this.loading = false;
            } else if (status === 'error') {
              this.message = 'Email is not correct.';
              this.messageType = 'danger';
              this.loading = false;
            }
          },
          error => {
            this.message = 'Unknown error.';
            this.messageType = 'danger';
            this.loading = false;
          }
        );
  }
}
